// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__Qu35s","loading_spinne":"styles_loading_spinne__CsQGD","spin":"styles_spin__LMueS"};